import * as React from 'react';
import { RenderLeafProps } from 'slate-react';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const FontSizeSwitcherLeaf = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() =>
  import('./components/FontSizeSwitcherLeaf').then((mod) => mod.FontSizeSwitcherLeaf),
));

export const renderLeafFontSizeSwitcher = () => (props: RenderLeafProps) =>
  <FontSizeSwitcherLeaf {...props} />;
